import { IQuoteResult } from "../../interfaces/results/IQuoteResult";
import { ApiQuoteResult } from "../../types/api/ApiQuoteResult";
import { parseClient } from "../helpers";
import BenefitResultMapper from "./BenefitResultMapper";
import EnumMapper from "./EnumMapper";
import { mapRemoteSettingToLocal } from "./mapper";

const remoteToLocal = (result: ApiQuoteResult): IQuoteResult => {
    return {
        benefits: result.benefits.map(BenefitResultMapper.remoteToLocal),
        paymentFrequency: EnumMapper.PaymentFrequency.remoteToLocal(result.frequency),
        policyFee: result.policyFee,
        policyFeeDiscount: result.policyFeeDiscount,
        premium: result.totalPremium,
        providerId: result.provider,
        providerName: result.providerName,
        errors: result.errors.map((s) => {
            return {
                type: EnumMapper.QuoteErrorType.remoteToLocal(s.type),
                message: s.message
            };
        }),
        totalDiscount: result.totalDiscount,
        totalPremium: result.totalPremium + result.policyFee,
        clients: result.clients.map(parseClient),
        settings: result.configurations.map(mapRemoteSettingToLocal),
        selectedAddOns: result.selectedAddOns
    };
};

export default {
    remoteToLocal
};
